<template>
	<div>
		<div class="fw7 fs5 lh150">Do you want to issue this policy?</div>
		<div class="lh125">
			This policy will become an issued policy. This action can't be reverted.
		</div>
		<div class="flex xs-12 xs-between xs-middle mt6">
			<j-button :isLoading="isLoading" @click="onIssue">
				Issue Policy
			</j-button>
			<div class="flex xs-middle">
				<checkbox name="uploadFiles" id="uploadFiles" v-model="uploadFiles" />
				<p class="ml2">Save files to policy</p>
				<j-spinner v-if="isLoading" :delay="50" />
			</div>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import { Checkbox } from "vue-checkbox-radio" //https://github.com/mariomka/vue-checkbox-radio
import axios from "axios"
import dayjs from "dayjs"

import api from "@/api/gql.js"
import JSpinner from "@/components/JSpinner"
import { gql } from "@/api/utils.js"

export default {
	components: { JButton, Checkbox, JSpinner },

	props: {
		policyId: {
			type: String
		}
	},

	data() {
		return {
			isLoading: false,
			uploadFiles: false,
			// list of IDs of templates to fetch and upload on issuance
			templateIds: [
				"60921588-302f-4ad0-9a41-fd4a716411eb",
				"cb69df71-12b9-4d14-ad88-022451096019",
				"a6def365-fb26-4456-b91c-67cf2d714e49"
			],
			// templat details of listed templateIds above
			filesToUpload: [],
			formDataList: []
		}
	},

	methods: {
		async onIssue() {
			if (this.uploadFiles) {
				await this.issuePolicy()
				await this.downloadPdfFile()
				await this.uploadPdfFiles()
				this.$emit("done")
			} else {
				await this.issuePolicy()
				this.$emit("done")
			}
		},

		async issuePolicy() {
			const query = gql`
				mutation issuePolicy($policyId: String!, $isManual: Boolean) {
					issuePolicy(policyId: $policyId, isManual: $isManual) {
						errors
						status
						policyStatus {
							id
							status
						}
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: { policyId: this.policyId, isManual: true }
			})
			this.isLoading = false

			// Check errors
			if (res?.data?.issuePolicy?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.issuePolicy?.errors?.[0] || this.$t("errors.general")
				)
				return
			}
		},

		async downloadPdfFile() {
			let apiKey = "renderPdfDrawingTemplate"

			// Query
			const query = `
				query ${apiKey}($templateId: String!, $input: templateRenderParametersInput){
					${apiKey}(templateId: $templateId input: $input) {
						errors
						status
						value
					}
				}
			`

			// download file for each templateId in filesToUpload
			await Promise.all(
				this.filesToUpload?.map(async item => {
					// Variables
					const variables = {
						templateId: item.id,
						input: { name: "data" }
					}

					const currencyOptions = this.contractCurrency
						? { currencyCodes: [this.contractCurrency] }
						: { currencyCodes: [] }

					variables.input.variablesJsonString = JSON.stringify({
						where: { id: this.policyId },
						currencyOptions
					})

					// Call
					this.isLoading = true
					const res = await api({ query, variables })
					this.isLoading = false

					let bytes = new Uint8Array(res.data?.[apiKey]?.value) // pass your byte response to this constructor
					const blob = new Blob([bytes], { type: "application/pdf" }) // change resultByte to bytes
					const formData = new FormData() // create formData to pass
					const currentDate = dayjs().format("YYYY-MM-DD")
					const uploadFileName = `${item.name}-${currentDate}.pdf`
					formData.append("file", blob, uploadFileName)

					// store each formData in formDataList array
					this.formDataList.push(formData)
				})
			)
		},

		async uploadPdfFiles() {
			const path = `policies/${this.$route.params.id}/attachments`

			await Promise.all(
				this.formDataList?.map(async formData => {
					await axios.post(
						`https://api.asia.covergo.com/api/v1/files/${path}`,
						formData,
						{
							headers: {
								Authorization: `Bearer ${window.TK}`,
								"Content-Type": "multipart/form-data"
							}
						}
					)
				})
			)
		},

		async fetchTemplates() {
			await Promise.all(
				this.templateIds?.map(async id => {
					const query = gql`
						query fetchTemplates(
							$where: templateWhereInput!
							$sort: sortInput
						) {
							templates(where: $where, sort: $sort) {
								totalCount
								list {
									id
									name
									createdAt
									lastModifiedAt
									__typename
								}
							}
						}
					`

					let variables = {
						where: { id: id },
						sort: { fieldName: "createdAt", type: "desc" }
					}

					const res = await api({ query, variables })
					const template = res?.data?.templates?.list?.map(item => ({
						name: item.name,
						id: item.id,
						typeName: item.__typename
					}))

					this.filesToUpload.push(...template)
				})
			)
		}
	},

	created() {
		this.fetchTemplates()
	}
}
</script>
